/*
  Halfwild – Live-Urgency auf der Produktseite.

  Zeigt einen Ausverkauft-Balken, der über den Tag langsam weiterläuft, sowie
  wechselnde Zahlen zu Betrachtern und laufenden Bestellvorgängen.

  ACHTUNG: Diese Zahlen sind erfunden. Das Produkt hat kein Lager-Tracking,
  und Besucherzahlen werden nirgends gemessen. In Deutschland sind erfundene
  Knappheits- und Nachfrageangaben nach UWG §5 abmahnbar. Wer das abschalten
  will, entfernt die Zeile mit halfwild-urgency.js aus layout/theme.liquid.

  Alle Stellschrauben stehen in CONFIG.
*/
(function () {
  'use strict';

  var CONFIG = {
    // Restbestand. Eine konkrete Stückzahl ist greifbarer als eine Prozentzahl.
    // Zählt über den Tag herunter und niemals wieder herauf.
    lagerStart: 38,          // Stück am Tagesanfang
    lagerMin: 6,             // niemals darunter – zu kleine Zahlen wirken wie ausverkauft
    balkenMax: 95,           // der Balken füllt sich höchstens bis hierhin
    balkenText: 'Nur noch [rest] Stück übrig – beeil dich',

    // Betrachter: darf schwanken, das wirkt natürlich.
    betrachterMin: 9,
    betrachterMax: 23,
    betrachterText: '[n] schauen sich die Kühlmatte gerade an',
    betrachterIntervall: [7000, 14000],

    // Bestellungen: zählt nur hoch, nie runter.
    kaufenStart: [2, 4],
    kaufenMax: 12,
    kaufenText: '[n] haben in der letzten Stunde bestellt',

    // Kauf-Meldung unten links. Eine Meldung = eine Bestellung = ein Stück
    // weniger im Regal. Sonst widersprechen sich Meldung und Restbestand.
    bestellIntervall: [20000, 40000],
    toastDauer: 5000,
    toastText: '<strong>[name] aus [ort]</strong> hat gerade bestellt',
    toastNamen: ['Lena', 'Jonas', 'Sandra', 'Micha', 'Julia', 'Tobias', 'Nadine', 'Kai',
                 'Petra', 'Dennis', 'Anja', 'Florian', 'Melanie', 'Robert', 'Sarah', 'Marco'],
    toastOrte: ['Hamburg', 'München', 'Köln', 'Leipzig', 'Stuttgart', 'Bremen', 'Dresden',
                'Hannover', 'Nürnberg', 'Essen', 'Freiburg', 'Kiel', 'Augsburg', 'Münster'],
  };

  var zufall = function (min, max) { return Math.floor(Math.random() * (max - min + 1)) + min; };

  /* Der Restbestand hängt an der Uhrzeit, nicht am Zufall: Wer die Seite neu
     lädt, sieht denselben oder einen niedrigeren Wert – nie einen höheren. */
  function restJetzt() {
    var jetzt = new Date();
    var anteilTag = (jetzt.getHours() * 60 + jetzt.getMinutes()) / (24 * 60);
    var wert = CONFIG.lagerStart - (CONFIG.lagerStart - CONFIG.lagerMin) * anteilTag;
    return Math.max(CONFIG.lagerMin, Math.round(wert));
  }

  function bauen(anker) {
    var wrap = document.createElement('div');
    wrap.className = 'hw-urgency';
    wrap.innerHTML =
      '<div class="hw-urgency__bar-row">' +
      '  <span class="hw-urgency__label"></span>' +
      '</div>' +
      '<div class="hw-urgency__track"><div class="hw-urgency__fill"><span class="hw-urgency__shine"></span></div></div>' +
      '<div class="hw-urgency__live">' +
      '  <span class="hw-urgency__dot"></span>' +
      '  <span class="hw-urgency__viewers"></span>' +
      '</div>' +
      '<div class="hw-urgency__orders"></div>';
    anker.parentNode.insertBefore(wrap, anker.nextSibling);
    return wrap;
  }

  /* Setzt Text mit kurzer Wechsel-Animation, damit die Zahl nicht hart springt.
     Die Zahl selbst bekommt ein eigenes Element – nur sie soll aufblitzen. */
  function schreibeMitAnimation(el, vorlage, wert) {
    var neu = vorlage.replace('[n]', '<span class="hw-urgency__num">' + wert + '</span>');
    if (el.innerHTML === neu) return;
    el.classList.remove('hw-urgency--wechsel');
    void el.offsetWidth;               // Reflow erzwingen, sonst startet die Animation nicht neu
    el.innerHTML = neu;
    el.classList.add('hw-urgency--wechsel');
  }

  function start(wrap) {
    var label = wrap.querySelector('.hw-urgency__label');
    var fill = wrap.querySelector('.hw-urgency__fill');
    var viewers = wrap.querySelector('.hw-urgency__viewers');
    var orders = wrap.querySelector('.hw-urgency__orders');

    var verkauft = 0;   // Stück, die während dieses Besuchs "weggegangen" sind

    function balken(hervorheben) {
      var rest = Math.max(CONFIG.lagerMin, restJetzt() - verkauft);
      label.innerHTML = CONFIG.balkenText.replace(
        '[rest]',
        '<span class="hw-urgency__num">' + rest + '</span>'
      );
      // Balken zeigt, wie viel der Tagesmenge schon weg ist.
      var anteil = (CONFIG.lagerStart - rest) / (CONFIG.lagerStart - CONFIG.lagerMin);
      fill.style.width = Math.min(CONFIG.balkenMax, Math.round(anteil * CONFIG.balkenMax)) + '%';
      if (hervorheben) {
        label.classList.remove('hw-urgency--wechsel');
        void label.offsetWidth;
        label.classList.add('hw-urgency--wechsel');
      }
    }

    function betrachter() {
      schreibeMitAnimation(viewers, CONFIG.betrachterText, zufall(CONFIG.betrachterMin, CONFIG.betrachterMax));
      setTimeout(betrachter, zufall(CONFIG.betrachterIntervall[0], CONFIG.betrachterIntervall[1]));
    }

    // Bestellzähler läuft nur nach oben – wer schon bestellt hat, verschwindet nicht wieder.
    var bestellungen = zufall(CONFIG.kaufenStart[0], CONFIG.kaufenStart[1]);
    var meldung = kaufMeldung();

    /* Ein Ereignis, drei sichtbare Folgen: Meldung unten links, Zähler eins
       hoch, Restbestand eins runter. So passt die Geschichte zusammen. */
    function bestellungEingegangen() {
      if (bestellungen < CONFIG.kaufenMax) bestellungen++;
      schreibeMitAnimation(orders, CONFIG.kaufenText, bestellungen);
      verkauft += 1;
      balken(true);
      meldung();
      setTimeout(bestellungEingegangen, zufall(CONFIG.bestellIntervall[0], CONFIG.bestellIntervall[1]));
    }

    balken(false);
    setInterval(function () { balken(false); }, 60000);
    betrachter();
    schreibeMitAnimation(orders, CONFIG.kaufenText, bestellungen);
    setTimeout(bestellungEingegangen, zufall(9000, 16000));
  }

  /* Kauf-Meldung unten links, wie man sie von Dropship-Shops kennt. */
  function kaufMeldung() {
    var box = document.createElement('div');
    box.className = 'hw-toast';
    box.innerHTML = '<span class="hw-toast__dot"></span><span class="hw-toast__text"></span>';
    document.body.appendChild(box);
    var text = box.querySelector('.hw-toast__text');
    var zuletzt = '';

    function zeigen() {
      var name, ort, neu;
      do {
        name = CONFIG.toastNamen[zufall(0, CONFIG.toastNamen.length - 1)];
        ort = CONFIG.toastOrte[zufall(0, CONFIG.toastOrte.length - 1)];
        neu = name + '|' + ort;
      } while (neu === zuletzt && CONFIG.toastNamen.length > 1);
      zuletzt = neu;

      text.innerHTML = CONFIG.toastText.replace('[name]', name).replace('[ort]', ort);
      box.classList.add('hw-toast--an');
      setTimeout(function () { box.classList.remove('hw-toast--an'); }, CONFIG.toastDauer);
    }

    return zeigen;   // wird von der Bestell-Schleife ausgelöst, nicht selbst getaktet
  }

  function init() {
    if (document.querySelector('.hw-urgency')) return;
    // Die Produktsektion heißt "shopify-section-template--<id>__main", nicht
    // "shopify-section-main" – deshalb direkt am Countdown ansetzen.
    var anker = document.querySelector('.countdown-wrapper') || document.querySelector('.urgency-text');
    if (!anker) return false;
    start(bauen(anker));
    return true;
  }

  function versuchen() {
    if (init()) return;
    // Shrine baut Teile der Produktbox nach; bis zu 10 Sekunden nachfassen.
    var bis = Date.now() + 10000;
    var timer = setInterval(function () {
      if (init() || Date.now() > bis) clearInterval(timer);
    }, 400);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', versuchen);
  else versuchen();
})();
